'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isSaturday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isSaturday.js
// module id = 316
// module chunks = 0